export const Settings = {
  mapKey: `AIzaSyAnHuYlbbD3g2shVg4h7ylzITk0JbYj7yg`,
};
